{
    "Policies_Board.status.submitted": "FR: Submitted",
    "Policies_Board.status.quoteIssued": "FR: Quote Issued",
    "Policies_Board.status.quoteAccepted": "FR: Quote Accepted",
    "Policies_Board.status.bindRequested": "FR: Bind Requested",

    "Policies_Board.type.renewal": "FR: Renewal",
    "Policies_Board.type.newBusiness": "FR: New Business",
    "Policies_Board.type.none": "FR: None",

    "Policies_Board.filter.type": "FR: Type",
    "Policies_Board.filter.allTransactionType": "FR: All Transaction Type",
    "Policies_Board.filter.renewals": "FR: Renewals",
    "Policies_Board.filter.newBusinesses": "FR: New Businesses",

    "Policies_Board.card.unassigned": "FR: Unassigned",
    "Policies_Board.card.status": "FR: Status",
    "Policies_Board.card.product": "FR: Product",
    "Policies_Board.card.effective": "FR: Effective",
    "Policies_Board.card.description": "FR: Description",
    "Policies_Board.card.address": "FR: Address",
    "Policies_Board.card.call": "FR: Call",
    "Policies_Board.card.email": "FR: Email",

    "Policies_Board.navigation.previous": "FR: <<",
    "Policies_Board.navigation.next": "FR: >>"
}
